import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { EditResourceModel } from "../models/LocalizationModels/EditResourceModel";
import { UploadJsonVM } from "../models/LocalizationModels/UploadJsonVM";
import { RequestHandlerService,AuthService, RequestOptionsModel } from "bnsights-utilities-library";



@Injectable({
    providedIn: 'root'
  })
export class localizationsService  {
    ApiUrl="/api/admin/Localizations/"
    constructor(private http: RequestHandlerService) {    
      }

Loaddropdowns()
{
  
  return this.http.get(this.ApiUrl +'Loaddropdowns');
}
AddResource(AddResourceModel:EditResourceModel)
{
  return this.http.post(this.ApiUrl +'AddResource',AddResourceModel);
}

EditResource(EditResourceModel:EditResourceModel)
{
 
  return this.http.post(this.ApiUrl +'EditResource',EditResourceModel);
}
RestResourceToFactoryDefault(EditResourceModel:EditResourceModel)
{
 
  return this.http.post(this.ApiUrl +'RestResourceToFactoryDefault',EditResourceModel);
}



UploadExcelFiles(UploadJsonVM:UploadJsonVM)
{
  
  return this.http.post(this.ApiUrl +'UploadExcelFiles',UploadJsonVM);
}


DeleteResource(ResourceList:any[])
{
  return this.http.post(this.ApiUrl +'DeleteResource',ResourceList);
}


ReloadJsonFile()
{
 
  return this.http.get(this.ApiUrl +'ReloadJsonFile');
}


RestToFactoryDefault()
{
 
  return this.http.get(this.ApiUrl +'RestToFactoryDefault');
}


RestUnmodifiedToFactoryDefault()
{
  
  return this.http.get(this.ApiUrl +'RestUnmodifiedToFactoryDefault');
}


GenerateStronglyTypedClass()
{
  
  return this.http.get(this.ApiUrl +'GenerateStronglyTypedClass');
}



Export(params:HttpParams)
{
  let options:RequestOptionsModel=new RequestOptionsModel()
  options.responseType= "arraybuffer" 
  return this.http.post(this.ApiUrl +'Export',null,params,options);
}


}